class Globals {
  visitorId;
  shardId;
  instanceId;
  biToken;
}

export default new Globals();




// WEBPACK FOOTER //
// ./chat-app/services/globals.js